"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var style_1 = require("./style");
var Button_1 = __importDefault(require("../../../Form/Elements/Button"));
var BreadcrumbBar = function (_a) {
    var title = _a.title, createButtonTitle = _a.createButtonTitle, createButtonAction = _a.createButtonAction, createButtonActions = _a.createButtonActions, breadcrumbsLinks = _a.breadcrumbsLinks;
    return (react_1.default.createElement(style_1.BreadcrumbContainer, null,
        react_1.default.createElement(style_1.Column, null,
            breadcrumbsLinks && (react_1.default.createElement(antd_1.Breadcrumb, null, breadcrumbsLinks.map(function (_a) {
                var label = _a.label, path = _a.path;
                return (react_1.default.createElement(antd_1.Breadcrumb.Item, { key: path }, label));
            }))),
            react_1.default.createElement(style_1.Title, null, title)),
        createButtonAction && (react_1.default.createElement(react_1.default.Fragment, null, createButtonActions ? (react_1.default.createElement(antd_1.Dropdown.Button, { onClick: createButtonAction, overlay: react_1.default.createElement(antd_1.Menu, { onClick: function (_a) {
                    var key = _a.key;
                    var index = parseInt(key.toString().replace("item_", ""), 10);
                    createButtonActions[index].action();
                } }, createButtonActions.map(function (_a) {
                var label = _a.label;
                return react_1.default.createElement(antd_1.Menu.Item, null, label);
            })) },
            react_1.default.createElement(icons_1.PlusOutlined, null),
            " ",
            createButtonTitle)) : (react_1.default.createElement(Button_1.default, { type: "default", onClick: createButtonAction, title: createButtonTitle, icon: react_1.default.createElement(icons_1.PlusOutlined, null) }))))));
};
exports.default = BreadcrumbBar;
